import { render, staticRenderFns } from "./associateMerchant.vue?vue&type=template&id=18f3fb9e&"
import script from "./associateMerchant.vue?vue&type=script&lang=js&"
export * from "./associateMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports